import React, { useState, useEffect } from 'react';

const API = 'https://api.pixventa.com';

const METODOS_PAGO = ['Transferencia','PayPal','Tarjeta','OXXO'];

const ESTADO_BADGE = {
  activo:    { bg:'#E1F5EE', color:'#085041', label:'Activo' },
  bloqueado: { bg:'#FCEBEB', color:'#501313', label:'Bloqueado' },
  prueba:    { bg:'#FFF3E0', color:'#E65100', label:'Prueba' },
};

const PAGO_BADGE = {
  activo:  { bg:'#E1F5EE', color:'#085041', label:'Pagado' },
  vencido: { bg:'#FCEBEB', color:'#501313', label:'Vencido' },
};

const CAMBIO_COLOR = {
  Registro:  '#075E54',
  Pago:      '#1565c0',
  Bloqueo:   '#c62828',
  Activación:'#085041',
  Edición:   '#7A8F89',
  Plan:      '#26215C',
};

const S = {
  topbar:     { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 },
  h1:         { fontSize:20, fontWeight:700, color:'#0D1F1A' },
  metrics:    { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:20 },
  metric:     { background:'white', borderRadius:12, padding:14, border:'1px solid #E4EDE8' },
  mLbl:       { fontSize:11, color:'#7A8F89', marginBottom:6 },
  mVal:       { fontSize:22, fontWeight:800, color:'#0D1F1A' },
  mSub:       { fontSize:10, color:'#7A8F89', marginTop:3 },
  filtros:    { display:'flex', gap:8, marginBottom:16 },
  sel:        { padding:'7px 12px', borderRadius:8, border:'1px solid #E4EDE8', background:'white', fontSize:12, color:'#0D1F1A', cursor:'pointer', fontFamily:'inherit' },
  inputBusq:  { padding:'7px 12px', borderRadius:8, border:'1px solid #E4EDE8', background:'white', fontSize:12, color:'#0D1F1A', outline:'none', fontFamily:'inherit', width:220 },
  card:       { background:'white', borderRadius:12, border:'1px solid #E4EDE8', overflow:'hidden', marginBottom:16 },
  table:      { width:'100%', borderCollapse:'collapse', fontSize:12 },
  th:         { padding:'9px 12px', textAlign:'left', fontSize:11, fontWeight:700, color:'#7A8F89', borderBottom:'1px solid #E4EDE8', background:'#F0F4F0' },
  td:         { padding:'10px 12px', borderBottom:'1px solid #E4EDE8', color:'#0D1F1A', verticalAlign:'middle' },
  badge:      { display:'inline-block', padding:'2px 8px', borderRadius:20, fontSize:11, fontWeight:600 },
  subdom:     { fontSize:11, color:'#7A8F89' },
  subdomSpan: { color:'#075E54', fontWeight:600 },
  btn:        { fontSize:11, padding:'4px 8px', borderRadius:8, border:'1px solid #E4EDE8', background:'none', color:'#7A8F89', cursor:'pointer', fontFamily:'inherit', marginRight:4 },
  btnOk:      { color:'#085041', borderColor:'#5DCAA5' },
  btnVer:     { color:'#042C53', borderColor:'#90caf9' },
  btnWA:      { color:'white', background:'#25D366', borderColor:'#25D366' },
  overlay:    { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:16 },
  modal:      { background:'white', borderRadius:16, padding:24, width:640, maxHeight:'92vh', overflowY:'auto' },
  mTitle:     { fontSize:16, fontWeight:800, color:'#0D1F1A', marginBottom:4 },
  mSubtitle:  { fontSize:12, color:'#7A8F89', marginBottom:20 },
  infoGrid:   { display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:16 },
  infoCard:   { background:'#F0F4F0', borderRadius:10, padding:12 },
  infoLbl:    { fontSize:10, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.5, marginBottom:4 },
  infoVal:    { fontSize:13, color:'#0D1F1A', fontWeight:500 },
  divider:    { height:1, background:'#E4EDE8', margin:'14px 0' },
  secTitle:   { fontSize:13, fontWeight:700, color:'#0D1F1A', marginBottom:10 },
  modalBtns:  { display:'flex', gap:8, marginTop:20, flexWrap:'wrap' },
  btnAction:  { padding:'9px 16px', borderRadius:10, border:'none', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  formOverlay:{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:300, display:'flex', alignItems:'center', justifyContent:'center' },
  formModal:  { background:'white', borderRadius:16, padding:24, width:440 },
  fTitle:     { fontSize:15, fontWeight:800, color:'#0D1F1A', marginBottom:16 },
  fField:     { marginBottom:14 },
  fLbl:       { display:'block', fontSize:11, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.5, marginBottom:5 },
  fInput:     { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, padding:'9px 12px', fontSize:13, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box' },
  fSelect:    { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, padding:'9px 12px', fontSize:13, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box', cursor:'pointer' },
  fGrid:      { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  fBtns:      { display:'flex', gap:8, marginTop:18 },
  fBtnCancel: { flex:1, padding:10, borderRadius:10, border:'1px solid #E4EDE8', background:'#F0F4F0', color:'#7A8F89', fontSize:13, cursor:'pointer', fontFamily:'inherit' },
  fBtnSave:   { flex:1, padding:10, borderRadius:10, border:'none', background:'#075E54', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  timeline:   { paddingLeft:16, borderLeft:'2px solid #E4EDE8' },
  timeItem:   { position:'relative', marginBottom:10, paddingBottom:2 },
  timeDot:    { position:'absolute', left:-21, top:4, width:8, height:8, borderRadius:'50%' },
  timeTipo:   { fontSize:11, fontWeight:700, marginBottom:1 },
  timeDetalle:{ fontSize:12, color:'#0D1F1A' },
  timeFecha:  { fontSize:10, color:'#7A8F89', marginTop:1 },
  cargando:   { textAlign:'center', padding:40, color:'#7A8F89', fontSize:13 },
  errorBox:   { background:'#FCEBEB', border:'1px solid #F09595', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#A32D2D', marginBottom:16 },
};

function formatFecha(str) {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('es-MX', { day:'2-digit', month:'short', year:'numeric' });
}

export default function Negocios() {
  const [negocios,       setNegocios]       = useState([]);
  const [planes,         setPlanes]         = useState([]);
  const [cargando,       setCargando]       = useState(true);
  const [errorMsg,       setErrorMsg]       = useState('');
  const [busqueda,       setBusqueda]       = useState('');
  const [filtroEstado,   setFiltroEstado]   = useState('todos');
  const [verNegocio,     setVerNegocio]     = useState(null);
  const [historialPagos, setHistorialPagos] = useState([]);
  const [historialCambios,setHistorialCambios]=useState([]);
  const [formPago,       setFormPago]       = useState(null);
  const [formPlan,       setFormPlan]       = useState(null);
  const [formEditar,     setFormEditar]     = useState(null);
  const [datosPago,      setDatosPago]      = useState({});
  const [datosPlan,      setDatosPlan]      = useState({});
  const [datosEditar,    setDatosEditar]    = useState({});
  const [hayCambios,     setHayCambios]     = useState(false);
  const [formNuevo,      setFormNuevo]      = useState(false);
  const [datosNuevo,     setDatosNuevo]     = useState({});
  const [guardandoNuevo, setGuardandoNuevo] = useState(false);
  const [errorNuevo,     setErrorNuevo]     = useState('');

  useEffect(() => { cargarDatos(); }, []);

  async function cargarDatos() {
    try {
      setCargando(true);
      const [rNegocios, rPlanes, rSus] = await Promise.all([
        fetch(`${API}/admin/tiendas`).then(r => r.json()),
        fetch(`${API}/admin/planes`).then(r => r.json()),
        fetch(`${API}/admin/suscripciones`).then(r => r.json()),
      ]);
      const negociosEnriquecidos = rNegocios.map(n => {
        const sus = rSus.filter(s => s.tienda_id === n.id);
        const susActiva = sus.find(s => s.estado === 'activo');
        const plan = rPlanes.find(p => p.id === n.plan_id);
        return {
          ...n,
          plan:        plan?.nombre || 'Sin plan',
          monto:       parseFloat(plan?.precio || 0),
          fechaInicio: susActiva ? formatFecha(susActiva.fecha_inicio) : '—',
          fechaFin:    susActiva ? formatFecha(susActiva.fecha_fin) : '—',
          metodoPago:  susActiva?.metodo_pago || '—',
          referencia:  susActiva?.referencia || '—',
          creado:      formatFecha(n.creado_en),
        };
      });
      setNegocios(negociosEnriquecidos);
      setPlanes(rPlanes);
    } catch (err) {
      setErrorMsg('Error cargando negocios: ' + err.message);
    } finally {
      setCargando(false);
    }
  }

  async function cargarHistorial(negocio) {
    try {
      const [rSus, rCambios] = await Promise.all([
        fetch(`${API}/admin/suscripciones`).then(r => r.json()),
        fetch(`${API}/admin/historial/${negocio.id}`).then(r => r.json()),
      ]);
      setHistorialPagos(rSus.filter(s => s.tienda_id === negocio.id));
      setHistorialCambios(rCambios);
    } catch (err) {
      console.error('Error cargando historial:', err);
    }
  }

  async function abrirManage(negocio) {
    setVerNegocio(negocio);
    await cargarHistorial(negocio);
  }

  function actualizarPago(c, v)   { setDatosPago(p => ({...p,[c]:v}));   setHayCambios(true); }
  function actualizarPlan(c, v)   { setDatosPlan(p => ({...p,[c]:v}));   setHayCambios(true); }
  function actualizarEditar(c, v) { setDatosEditar(p => ({...p,[c]:v})); setHayCambios(true); }

  function cerrarFormPago() { if (hayCambios && !window.confirm('¿Cerrar sin guardar?')) return; setFormPago(null); setDatosPago({}); setHayCambios(false); }
  function cerrarFormPlan() { if (hayCambios && !window.confirm('¿Cerrar sin guardar?')) return; setFormPlan(null); setDatosPlan({}); setHayCambios(false); }
  function cerrarFormEditar() {
    if (hayCambios && !window.confirm('¿Cerrar sin guardar?')) return;
    const negocioActual = negocios.find(n => n.id === formEditar?.id);
    setFormEditar(null); setDatosEditar({}); setHayCambios(false);
    if (negocioActual) setVerNegocio(negocioActual);
  }

  async function confirmarToggle(negocio) {
    const accion = negocio.estado === 'activo' ? 'bloquear' : 'activar';
    if (!window.confirm(`¿Seguro que quieres ${accion} "${negocio.nombre}"?`)) return;
    const nuevoEstado = negocio.estado === 'activo' ? 'bloqueado' : 'activo';
    try {
      await fetch(`${API}/admin/tiendas/${negocio.id}`, { method:'PUT', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ ...negocio, estado: nuevoEstado }) });
      await fetch(`${API}/admin/historial`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ tienda_id: negocio.id, tipo: nuevoEstado==='bloqueado'?'Bloqueo':'Activación', detalle:`Cuenta ${nuevoEstado==='bloqueado'?'bloqueada':'activada'} manualmente` }) });
      setNegocios(prev => prev.map(n => n.id===negocio.id ? {...n, estado: nuevoEstado} : n));
      if (verNegocio?.id === negocio.id) { setVerNegocio(prev => ({...prev, estado: nuevoEstado})); await cargarHistorial({...negocio, estado: nuevoEstado}); }
    } catch (err) { alert('Error: ' + err.message); }
  }

  function abrirFormPago(negocio) {
    setDatosPago({ metodoPago:'', referencia:'', fechaInicio: new Date().toISOString().split('T')[0], fechaFin:'', monto: negocio.monto });
    setHayCambios(false); setFormPago(negocio);
  }

  async function guardarPago() {
    if (!datosPago.metodoPago)        { alert('Selecciona el método de pago'); return; }
    if (!datosPago.fechaFin)          { alert('Selecciona la fecha de vencimiento'); return; }
    if (!datosPago.referencia?.trim()){ alert('Escribe la referencia del pago'); return; }
    const monto = parseFloat(String(datosPago.monto).replace(/,/g,'')) || 0;
    const planInfo = planes.find(p => p.nombre === formPago.plan);
    try {
      await fetch(`${API}/admin/suscripciones`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ tienda_id: formPago.id, plan_id: planInfo?.id, monto, metodo_pago: datosPago.metodoPago, referencia: datosPago.referencia, fecha_inicio: datosPago.fechaInicio, fecha_fin: datosPago.fechaFin }) });
      await fetch(`${API}/admin/historial`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ tienda_id: formPago.id, tipo:'Pago', detalle:`Pago registrado — ${datosPago.referencia} — $${monto.toLocaleString('es-MX',{minimumFractionDigits:2})}` }) });
      await cargarDatos();
      if (verNegocio?.id === formPago.id) await cargarHistorial(formPago);
      setFormPago(null); setDatosPago({}); setHayCambios(false);
    } catch (err) { alert('Error registrando pago: ' + err.message); }
  }

  function abrirFormPlan(negocio) { setDatosPlan({ plan_id: negocio.plan_id }); setHayCambios(false); setFormPlan(negocio); }

  async function guardarPlan() {
    if (!datosPlan.plan_id) { alert('Selecciona un plan'); return; }
    const planInfo = planes.find(p => p.id === parseInt(datosPlan.plan_id));
    try {
      await fetch(`${API}/admin/tiendas/${formPlan.id}`, { method:'PUT', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ ...formPlan, plan_id: planInfo.id }) });
      await fetch(`${API}/admin/historial`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ tienda_id: formPlan.id, tipo:'Plan', detalle:`Plan cambiado de ${formPlan.plan} a ${planInfo.nombre}` }) });
      await cargarDatos();
      if (verNegocio?.id === formPlan.id) await cargarHistorial(formPlan);
      setFormPlan(null); setDatosPlan({}); setHayCambios(false);
    } catch (err) { alert('Error cambiando plan: ' + err.message); }
  }

  function abrirFormEditar(negocio) {
    setDatosEditar({ nombre: negocio.nombre, propietario: negocio.propietario, email: negocio.email, tel: negocio.tel });
    setHayCambios(false); setFormEditar(negocio);
  }

  async function guardarEdicion() {
    if (!datosEditar.nombre.trim())      { alert('Escribe el nombre del negocio'); return; }
    if (!datosEditar.propietario.trim()) { alert('Escribe el nombre del propietario'); return; }
    if (!datosEditar.email.trim())       { alert('Escribe el email'); return; }
    if (!datosEditar.tel.trim())         { alert('Escribe el teléfono'); return; }
    try {
      await fetch(`${API}/admin/tiendas/${formEditar.id}`, { method:'PUT', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ ...formEditar, ...datosEditar }) });
      await fetch(`${API}/admin/historial`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ tienda_id: formEditar.id, tipo:'Edición', detalle:'Datos editados: nombre, propietario, email, teléfono' }) });
      await cargarDatos();
      const actualizado = { ...formEditar, ...datosEditar };
      setFormEditar(null); setDatosEditar({}); setHayCambios(false);
      setVerNegocio(actualizado);
      await cargarHistorial(actualizado);
    } catch (err) { alert('Error guardando: ' + err.message); }
  }

  function solicitarPago(negocio) {
    const num = (negocio.tel || '').replace(/\D/g,'');
    const msg = `Hola ${(negocio.propietario||'').split(' ')[0]} 👋\n\nTe recordamos que tu suscripción de *WhatMarket* (${negocio.plan}) ha vencido.\n\nPara continuar usando tu tienda *${negocio.subdominio}.pixventa.com* por favor realiza tu pago de $${Number(negocio.monto).toLocaleString('es-MX',{minimumFractionDigits:2})} MXN.\n\n¿Tienes alguna duda? Con gusto te ayudamos. 🙏`;
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(msg)}`, '_blank');
  }

  function abrirNuevoNegocio() {
    setDatosNuevo({ nombre:'', subdominio:'', propietario:'', email:'', tel:'', plan_id:'', fechaPrueba:'' });
    setErrorNuevo(''); setFormNuevo(true);
  }

  function cerrarNuevoNegocio() {
    if (Object.values(datosNuevo).some(v => v) && !window.confirm('¿Cerrar sin guardar?')) return;
    setFormNuevo(false); setDatosNuevo({}); setErrorNuevo('');
  }

  async function guardarNuevoNegocio() {
    setErrorNuevo('');
    if (!datosNuevo.nombre.trim())      { setErrorNuevo('Escribe el nombre del negocio'); return; }
    if (!datosNuevo.subdominio.trim())  { setErrorNuevo('Escribe el subdominio'); return; }
    if (!datosNuevo.propietario.trim()) { setErrorNuevo('Escribe el nombre del propietario'); return; }
    if (!datosNuevo.email.trim())       { setErrorNuevo('Escribe el email'); return; }
    if (!datosNuevo.tel.trim())         { setErrorNuevo('Escribe el teléfono'); return; }
    if (!datosNuevo.plan_id)            { setErrorNuevo('Selecciona un plan'); return; }

    const subdominio = datosNuevo.subdominio.toLowerCase().replace(/[^a-z0-9-]/g,'');
    setGuardandoNuevo(true);
    try {
      const res = await fetch(`${API}/admin/tiendas`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ nombre: datosNuevo.nombre, subdominio, propietario: datosNuevo.propietario, email: datosNuevo.email, tel: datosNuevo.tel, plan_id: datosNuevo.plan_id, estado:'prueba' }),
      });
      const data = await res.json();
      if (data.error) { setErrorNuevo(data.error); return; }

      await fetch(`${API}/admin/historial`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ tienda_id: data.id, tipo:'Registro', detalle:'Negocio registrado en WhatMarket — Periodo de prueba iniciado' }),
      });

      if (datosNuevo.fechaPrueba) {
        await fetch(`${API}/admin/suscripciones`, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({
            tienda_id:   data.id,
            plan_id:     datosNuevo.plan_id,
            monto:       0,
            metodo_pago: 'Prueba',
            referencia:  'Periodo de prueba',
            fecha_inicio: new Date().toISOString().split('T')[0],
            fecha_fin:    datosNuevo.fechaPrueba,
          }),
        });
      }

      await cargarDatos();
      setFormNuevo(false); setDatosNuevo({}); setErrorNuevo('');
    } catch (err) {
      setErrorNuevo('Error: ' + err.message);
    } finally {
      setGuardandoNuevo(false);
    }
  }

  const filtrados    = negocios.filter(n => {
    const matchBusq   = (n.nombre||'').toLowerCase().includes(busqueda.toLowerCase()) || (n.subdominio||'').toLowerCase().includes(busqueda.toLowerCase());
    const matchEstado = filtroEstado === 'todos' || n.estado === filtroEstado;
    return matchBusq && matchEstado;
  });

  const totalMRR     = negocios.filter(n => n.estado==='activo').reduce((a, n) => a + Number(n.monto), 0);
  const totalActivos = negocios.filter(n => n.estado==='activo').length;
  const totalBloqued = negocios.filter(n => n.estado==='bloqueado').length;
  const totalPrueba  = negocios.filter(n => n.estado==='prueba').length;

  if (cargando) return <div style={S.cargando}>Cargando negocios...</div>;

  return (
    <div>
      <div style={S.topbar}>
        <h1 style={S.h1}>Negocios ({negocios.length})</h1>
        <button style={{ padding:'8px 16px', borderRadius:10, border:'none', background:'#075E54', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }} onClick={abrirNuevoNegocio}>＋ Nuevo negocio</button>
      </div>

      {errorMsg && <div style={S.errorBox}>{errorMsg}</div>}

      <div style={S.metrics}>
        <div style={S.metric}><div style={S.mLbl}>MRR activo</div><div style={{...S.mVal,color:'#075E54'}}>${totalMRR.toLocaleString('es-MX',{minimumFractionDigits:2})}</div><div style={S.mSub}>Suscripciones activas</div></div>
        <div style={S.metric}><div style={S.mLbl}>Activos</div><div style={S.mVal}>{totalActivos}</div><div style={S.mSub}>Al corriente</div></div>
        <div style={S.metric}><div style={S.mLbl}>Bloqueados</div><div style={{...S.mVal,color:'#A32D2D'}}>{totalBloqued}</div><div style={S.mSub}>Requieren atención</div></div>
        <div style={S.metric}><div style={S.mLbl}>En prueba</div><div style={{...S.mVal,color:'#E65100'}}>{totalPrueba}</div><div style={S.mSub}>Periodo de prueba</div></div>
      </div>

      <div style={S.filtros}>
        <input style={S.inputBusq} placeholder="🔍 Buscar negocio..." value={busqueda} onChange={e => setBusqueda(e.target.value)} />
        <select style={S.sel} value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
          <option value="todos">Todos los estados</option>
          <option value="activo">Activos</option>
          <option value="bloqueado">Bloqueados</option>
          <option value="prueba">En prueba</option>
        </select>
      </div>

      <div style={S.card}>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>Negocio</th>
              <th style={S.th}>Propietario</th>
              <th style={S.th}>Plan</th>
              <th style={S.th}>Vigencia</th>
              <th style={S.th}>Estado</th>
              <th style={S.th}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filtrados.length === 0 && (
              <tr><td colSpan={6} style={{...S.td, textAlign:'center', color:'#7A8F89', padding:32}}>Sin negocios registrados</td></tr>
            )}
            {filtrados.map(n => {
              const estado = ESTADO_BADGE[n.estado] || ESTADO_BADGE.prueba;
              return (
                <tr key={n.id}>
                  <td style={S.td}>
                    <div style={{fontWeight:700}}>{n.nombre}</div>
                    <div style={S.subdom}><span style={S.subdomSpan}>{n.subdominio}</span>.pixventa.com</div>
                  </td>
                  <td style={S.td}>
                    <div>{n.propietario}</div>
                    <div style={{fontSize:11,color:'#7A8F89'}}>{n.email}</div>
                  </td>
                  <td style={S.td}>{n.plan} — ${Number(n.monto).toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
                  <td style={S.td}>
                    <div style={{fontSize:11}}>{n.fechaInicio} →</div>
                    <div style={{fontSize:11,fontWeight:700,color:n.estado==='bloqueado'?'#A32D2D':'#0D1F1A'}}>{n.fechaFin}</div>
                  </td>
                  <td style={S.td}><span style={{...S.badge,background:estado.bg,color:estado.color}}>{estado.label}</span></td>
                  <td style={S.td}>
                    <button style={{...S.btn,...S.btnVer}} onClick={() => abrirManage(n)}>👁 Manage</button>
                    {(n.estado==='bloqueado'||n.estado==='prueba') && (
                      <button style={{...S.btn,...S.btnWA}} onClick={() => solicitarPago(n)}>📲 Cobrar</button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Modal Manage */}
      {verNegocio && (
        <div style={S.overlay} onClick={e => e.target===e.currentTarget && setVerNegocio(null)}>
          <div style={S.modal}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4 }}>
              <div style={S.mTitle}>🏪 {verNegocio.nombre}</div>
              <button onClick={() => setVerNegocio(null)} style={{ background:'#F0F4F0', border:'none', borderRadius:'50%', width:30, height:30, cursor:'pointer', fontSize:14, color:'#7A8F89', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
            </div>
            <div style={S.mSubtitle}>{verNegocio.subdominio}.pixventa.com · Registrado: {verNegocio.creado}</div>
            <div style={S.infoGrid}>
              <div style={S.infoCard}><div style={S.infoLbl}>Propietario</div><div style={S.infoVal}>{verNegocio.propietario}</div></div>
              <div style={S.infoCard}><div style={S.infoLbl}>Email</div><div style={S.infoVal}>{verNegocio.email}</div></div>
              <div style={S.infoCard}><div style={S.infoLbl}>Teléfono</div><div style={S.infoVal}>{verNegocio.tel}</div></div>
              <div style={S.infoCard}><div style={S.infoLbl}>Plan actual</div><div style={S.infoVal}>{verNegocio.plan} — ${Number(verNegocio.monto).toLocaleString('es-MX',{minimumFractionDigits:2})}/mes</div></div>
              <div style={S.infoCard}><div style={S.infoLbl}>Estado</div><span style={{...S.badge,...(ESTADO_BADGE[verNegocio.estado]||ESTADO_BADGE.prueba)}}>{(ESTADO_BADGE[verNegocio.estado]||ESTADO_BADGE.prueba).label}</span></div>
              <div style={S.infoCard}><div style={S.infoLbl}>Vigencia</div><div style={S.infoVal}>{verNegocio.fechaInicio} → {verNegocio.fechaFin}</div></div>
            </div>
            <div style={S.divider} />
            <div style={S.secTitle}>Historial de pagos</div>
            {historialPagos.length === 0 ? (
              <div style={{fontSize:12,color:'#7A8F89',marginBottom:12}}>Sin historial de pagos aún</div>
            ) : (
              <table style={{...S.table,marginBottom:12}}>
                <thead><tr><th style={S.th}>Fecha</th><th style={S.th}>Plan</th><th style={S.th}>Monto</th><th style={S.th}>Método</th><th style={S.th}>Referencia</th><th style={S.th}>Estado</th></tr></thead>
                <tbody>
                  {historialPagos.map((h, i) => {
                    const badge = PAGO_BADGE[h.estado] || PAGO_BADGE.activo;
                    return (
                      <tr key={i}>
                        <td style={S.td}>{formatFecha(h.fecha_inicio)}</td>
                        <td style={S.td}>{h.plan_nombre}</td>
                        <td style={{...S.td,fontWeight:700,color:'#075E54'}}>${Number(h.monto).toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
                        <td style={S.td}>{h.metodo_pago}</td>
                        <td style={S.td}>{h.referencia}</td>
                        <td style={S.td}><span style={{...S.badge,background:badge.bg,color:badge.color}}>{badge.label}</span></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            <div style={S.divider} />
            <div style={S.secTitle}>Historial de cambios</div>
            {historialCambios.length === 0 ? (
              <div style={{fontSize:12,color:'#7A8F89',marginBottom:12}}>Sin cambios registrados</div>
            ) : (
              <div style={{...S.timeline,marginBottom:12}}>
                {historialCambios.map((c, i) => (
                  <div key={i} style={S.timeItem}>
                    <div style={{...S.timeDot,background:CAMBIO_COLOR[c.tipo]||'#7A8F89'}} />
                    <div style={{...S.timeTipo,color:CAMBIO_COLOR[c.tipo]||'#7A8F89'}}>{c.tipo}</div>
                    <div style={S.timeDetalle}>{c.detalle}</div>
                    <div style={S.timeFecha}>{formatFecha(c.creado_en)}</div>
                  </div>
                ))}
              </div>
            )}
            <div style={S.modalBtns}>
              <button style={{...S.btnAction,background:'#F0F4F0',color:'#0D1F1A'}} onClick={() => abrirFormEditar(verNegocio)}>✏️ Editar datos</button>
              <button style={{...S.btnAction,background:'#E6F1FB',color:'#042C53'}} onClick={() => abrirFormPlan(verNegocio)}>📦 Cambiar plan</button>
              {(verNegocio.estado==='bloqueado'||verNegocio.estado==='prueba') && (
                <button style={{...S.btnAction,background:'#E1F5EE',color:'#085041'}} onClick={() => abrirFormPago(verNegocio)}>💳 Registrar pago</button>
              )}
              <button style={{...S.btnAction,background:'#25D366',color:'white'}} onClick={() => solicitarPago(verNegocio)}>📲 Solicitar pago</button>
              {verNegocio.estado==='activo'
                ? <button style={{...S.btnAction,background:'#FCEBEB',color:'#A32D2D'}} onClick={() => confirmarToggle(verNegocio)}>✕ Bloquear</button>
                : <button style={{...S.btnAction,background:'#E1F5EE',color:'#085041'}} onClick={() => confirmarToggle(verNegocio)}>✓ Activar</button>
              }
            </div>
          </div>
        </div>
      )}

      {/* Modal editar datos */}
      {formEditar && (
        <div style={S.formOverlay}>
          <div style={S.formModal}>
            <div style={S.fTitle}>✏️ Editar datos — {formEditar.nombre}</div>
            <div style={S.fField}><label style={S.fLbl}>Nombre del negocio</label><input style={S.fInput} value={datosEditar.nombre||''} onChange={e => actualizarEditar('nombre', e.target.value)} /></div>
            <div style={S.fField}><label style={S.fLbl}>Propietario</label><input style={S.fInput} value={datosEditar.propietario||''} onChange={e => actualizarEditar('propietario', e.target.value)} /></div>
            <div style={S.fGrid}>
              <div style={S.fField}><label style={S.fLbl}>Email</label><input style={S.fInput} value={datosEditar.email||''} onChange={e => actualizarEditar('email', e.target.value)} /></div>
              <div style={S.fField}><label style={S.fLbl}>Teléfono</label><input style={S.fInput} value={datosEditar.tel||''} onChange={e => actualizarEditar('tel', e.target.value)} /></div>
            </div>
            <div style={{fontSize:11,color:'#7A8F89',marginBottom:14,padding:'8px 12px',background:'#F0F4F0',borderRadius:8}}>🔒 El subdominio no puede modificarse una vez creado</div>
            <div style={S.fBtns}>
              <button style={S.fBtnCancel} onClick={cerrarFormEditar}>Cancelar</button>
              <button style={S.fBtnSave} onClick={guardarEdicion}>✓ Guardar cambios</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal registrar pago */}
      {formPago && (
        <div style={S.formOverlay} onClick={e => e.target===e.currentTarget && cerrarFormPago()}>
          <div style={S.formModal}>
            <div style={S.fTitle}>💳 Registrar pago — {formPago.nombre}</div>
            <div style={S.fGrid}>
              <div style={S.fField}><label style={S.fLbl}>Método de pago</label>
                <select style={S.fSelect} value={datosPago.metodoPago||''} onChange={e => actualizarPago('metodoPago', e.target.value)}>
                  <option value="">Selecciona...</option>
                  {METODOS_PAGO.map(m => <option key={m} value={m}>{m}</option>)}
                </select>
              </div>
              <div style={S.fField}><label style={S.fLbl}>Monto ($MXN)</label>
                <input style={S.fInput} type="text" inputMode="decimal" value={datosPago.monto||''}
                  onFocus={e => e.target.select()}
                  onChange={e => actualizarPago('monto', e.target.value.replace(/[^0-9.]/g,''))}
                  onBlur={e => { const n=parseFloat(e.target.value)||0; actualizarPago('monto',n.toLocaleString('es-MX',{minimumFractionDigits:2})); }}
                />
              </div>
              <div style={S.fField}><label style={S.fLbl}>Fecha de inicio</label><input style={S.fInput} type="date" value={datosPago.fechaInicio||''} onChange={e => actualizarPago('fechaInicio', e.target.value)} /></div>
              <div style={S.fField}><label style={S.fLbl}>Fecha de vencimiento</label><input style={S.fInput} type="date" value={datosPago.fechaFin||''} min={datosPago.fechaInicio} onChange={e => actualizarPago('fechaFin', e.target.value)} /></div>
            </div>
            <div style={S.fField}><label style={S.fLbl}>Referencia / Comprobante</label><input style={S.fInput} placeholder="Ej. TRF-12345" value={datosPago.referencia||''} onChange={e => actualizarPago('referencia', e.target.value)} /></div>
            <div style={S.fBtns}>
              <button style={S.fBtnCancel} onClick={cerrarFormPago}>Cancelar</button>
              <button style={S.fBtnSave} onClick={guardarPago}>✓ Confirmar pago</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal cambiar plan */}
      {formPlan && (
        <div style={S.formOverlay} onClick={e => e.target===e.currentTarget && cerrarFormPlan()}>
          <div style={{...S.formModal,width:360}}>
            <div style={S.fTitle}>📦 Cambiar plan — {formPlan.nombre}</div>
            <div style={S.fField}>
              <label style={S.fLbl}>Plan actual: <strong>{formPlan.plan}</strong></label>
              <select style={S.fSelect} value={datosPlan.plan_id||''} onChange={e => actualizarPlan('plan_id', e.target.value)}>
                <option value="">Selecciona el nuevo plan...</option>
                {planes.map(p => <option key={p.id} value={p.id}>{p.nombre} — ${Number(p.precio).toLocaleString('es-MX',{minimumFractionDigits:2})}/mes</option>)}
              </select>
            </div>
            <div style={S.fBtns}>
              <button style={S.fBtnCancel} onClick={cerrarFormPlan}>Cancelar</button>
              <button style={S.fBtnSave} onClick={guardarPlan}>✓ Cambiar plan</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal nuevo negocio */}
      {formNuevo && (
        <div style={S.formOverlay} onClick={e => e.target===e.currentTarget && cerrarNuevoNegocio()}>
          <div style={{ ...S.formModal, width:480 }}>
            <div style={S.fTitle}>🏪 Nuevo negocio</div>
            {errorNuevo && <div style={{ background:'#FCEBEB', border:'1px solid #F09595', borderRadius:10, padding:'10px 12px', fontSize:12, color:'#A32D2D', marginBottom:14 }}>⚠️ {errorNuevo}</div>}
            <div style={S.fField}>
              <label style={S.fLbl}>Nombre del negocio</label>
              <input style={S.fInput} placeholder="Ej. Botas García" value={datosNuevo.nombre||''} onChange={e => setDatosNuevo(p=>({...p,nombre:e.target.value}))} />
            </div>
            <div style={S.fField}>
              <label style={S.fLbl}>Subdominio</label>
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <input style={S.fInput} placeholder="botas-garcia" value={datosNuevo.subdominio||''} onChange={e => setDatosNuevo(p=>({...p,subdominio:e.target.value.toLowerCase().replace(/[^a-z0-9-]/g,'')}))} />
                <span style={{ fontSize:12, color:'#7A8F89', whiteSpace:'nowrap' }}>.pixventa.com</span>
              </div>
            </div>
            <div style={S.fField}>
              <label style={S.fLbl}>Propietario</label>
              <input style={S.fInput} placeholder="Nombre completo" value={datosNuevo.propietario||''} onChange={e => setDatosNuevo(p=>({...p,propietario:e.target.value}))} />
            </div>
            <div style={S.fGrid}>
              <div style={S.fField}>
                <label style={S.fLbl}>Email</label>
                <input style={S.fInput} placeholder="correo@ejemplo.com" value={datosNuevo.email||''} onChange={e => setDatosNuevo(p=>({...p,email:e.target.value}))} />
              </div>
              <div style={S.fField}>
                <label style={S.fLbl}>Teléfono</label>
                <input style={S.fInput} placeholder="+52 33 0000 0000" value={datosNuevo.tel||''} onChange={e => setDatosNuevo(p=>({...p,tel:e.target.value}))} />
              </div>
            </div>
            <div style={S.fGrid}>
              <div style={S.fField}>
                <label style={S.fLbl}>Plan</label>
                <select style={S.fSelect} value={datosNuevo.plan_id||''} onChange={e => setDatosNuevo(p=>({...p,plan_id:e.target.value}))}>
                  <option value="">Selecciona...</option>
                  {planes.map(p => <option key={p.id} value={p.id}>{p.nombre} — {Number(p.precio)===0?'Sin costo':`$${Number(p.precio).toLocaleString('es-MX')}/mes`}</option>)}
                </select>
              </div>
              <div style={S.fField}>
                <label style={S.fLbl}>Fin periodo de prueba</label>
                <input style={S.fInput} type="date" value={datosNuevo.fechaPrueba||''} min={new Date().toISOString().split('T')[0]} onChange={e => setDatosNuevo(p=>({...p,fechaPrueba:e.target.value}))} />
              </div>
            </div>
            <div style={{ fontSize:11, color:'#7A8F89', padding:'8px 12px', background:'#F0F4F0', borderRadius:8, marginBottom:14 }}>
              ℹ️ El negocio se creará en estado <strong>Prueba</strong>. Puedes activarlo al registrar el primer pago.
            </div>
            <div style={S.fBtns}>
              <button style={S.fBtnCancel} onClick={cerrarNuevoNegocio}>Cancelar</button>
              <button style={{ ...S.fBtnSave, opacity: guardandoNuevo?0.7:1 }} onClick={guardarNuevoNegocio} disabled={guardandoNuevo}>
                {guardandoNuevo ? 'Guardando...' : '✓ Crear negocio'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}